import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {TableRow,TableCell,IconButton,Collapse,Typography,Box,Table,TableHead,TableBody,Tooltip } from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import moment from 'moment';
import SendIcon from '@material-ui/icons/Send';
import IntlMessages from 'util/IntlMessages';
const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
});
function TableRowsJ(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
    return (
        <React.Fragment>
        <TableRow className={classes.root}>
            <TableCell>
                <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                    {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
            </TableCell>
            <TableCell component="th" scope="row">
                {row.type}
            </TableCell>
            <TableCell align="left" style={{color:props.CurrentDateTime > `${row.startdate} ${moment(new Date(row.starttime)).format("HH:mm")}`?"#ff0000":"#000"}}>{row.startdate} {moment(row.starttime).format("HH:mm")}
            </TableCell>
            <TableCell align="left">{row.AF_kundnamn}</TableCell>
            <TableCell align="right">{
            parseInt(row.ismote) === 1?
            <Tooltip title={<IntlMessages id="Title.Goto.Meeting"/>} placement="top">
            <IconButton color="primary" aria-label="Gå till möte" component="span"
             size={"small"} onClick={()=>props.GotoMote(row)}>
                <SendIcon />
            </IconButton>  
            </Tooltip>
            :
            parseInt(row.ismote) === 0?
            <Tooltip title={<IntlMessages id="Title.Goto.Activity"/>} placement="top">
            <IconButton color="primary" aria-label="Gå till aktivitet" component="span"
            size={"small"} onClick={()=>props.GotoAktivitet(row)}>
                <SendIcon />
            </IconButton>  
            </Tooltip>
            :""
            }</TableCell>
        </TableRow>
        <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box margin={1}>
                        <Typography variant="h6" gutterBottom component="div">
                        <IntlMessages id="Information.header"/>
                        </Typography>
                        <Table size="small" aria-label="purchases">
                            <TableHead>
                                <TableRow>
                                    {/* <TableCell>Date</TableCell>
                                    <TableCell>Customer</TableCell>
                                    <TableCell align="right">Amount</TableCell>
                                    <TableCell align="right">Total price ($)</TableCell> */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                   <TableRow>
                                        <div>
                                            <p dangerouslySetInnerHTML={{ __html:row.Body }}></p>
                                        </div>
                                       
                                    </TableRow>
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow>
    </React.Fragment>
    );
}

export default TableRowsJ;